export const proProgramsData = [{
    id: 1,
    title: "Advanced EEG Technology",
    description:
        "Brain Zen Pro uses advanced EEG technology for real-time feedback. It helps clinicians treat mental health issues. It uses live brainwave data to encourage the brain toward healthier patterns.",
},
{
    id: 2,
    title: "Personalized Treatment",
    description:
        "Brain Zen Pro offers suitable treatments based on individual brainwave patterns and needs. This ensures that each patient receives the most beneficial care.",
},
{
    id: 3,
    title: "Affordable Program",
    description:
        "Brain Zen Pro is affordable and has no starting costs. MITSI covers all program costs, including equipment and salaries. You only pay for sessions with confirmed reimbursements.",
},
{
    id: 4,
    title: "Training & Ongoing Support",
    description:
        "MITSI will train and support you. This will ensure a smooth transition of Brain Zen Pro into your practice. They will handle the setup and ongoing support.",
}];